import { useDayjs, useLogger } from '#imports'
import useLayeredContent from './useLayeredContent'
import type { PressArticle } from '../../utils/press-config'
import { normalizeSeo } from '../../utils/seo-schema'

export function useContentPress() {
    const { queryAll, queryBySlug } = useLayeredContent()
    const dayjs = useDayjs()
    const logger = useLogger()

    /**
     * Get press articles sorted by publishAt date descending (newest first).
     */
    async function getPressArticles() {
        const all = await queryAll<PressArticle>('press/posts')
        return all.sort((a, b) => {
            const dateA = a.publishAt ? dayjs(a.publishAt).valueOf() : 0
            const dateB = b.publishAt ? dayjs(b.publishAt).valueOf() : 0
            return dateB - dateA
        })
    }

    async function getPressArticleBySlug(slug: string) {
        const article = await queryBySlug<PressArticle>('press/posts', slug)
        if (!article) return null
        // The legacy CMS exported press SEO as a repeatable component, so the YAML holds `SEO: []`.
        const seo: unknown = Array.isArray(article.SEO) ? article.SEO[0] : article.SEO
        return {
            ...article,
            SEO: normalizeSeo(seo, value => logger.error(`Malformed SEO on press article "${slug}":`, value)),
        }
    }

    return { getPressArticles, getPressArticleBySlug }
}
